// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2OPH6","colMaxWidth":"Table_colMaxWidth__3EzqY"};